import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import QzTrayPublicCertificateService from "../../services/qztray/QzTrayPublicCertificateService";
import { setLoading, setCertificate, setCertificateError } from "../../store/slices/qztray/qzTrayPublicCertificateSlice";


/**
 * 🔓 Hook: useQzTrayPublicCertificate
 *
 * Encargado de obtener y almacenar el certificado público (cert.pem)
 * necesario para inicializar la conexión segura con QZ Tray.
 */
export const useQzTrayPublicCertificate = () => {
    const dispatch = useDispatch();

    const { certificate, isLoading, error } = useSelector(
        (state: RootState) => state.qzTrayPublicCertificate
    );

    /**
     * 📥 Cargar certificado desde backend y almacenarlo en Redux
     */
    const fetchCertificate = async () => {
        try {
            dispatch(setLoading(true));

            const response = await QzTrayPublicCertificateService.getPublicCertificate();
            const { statusCode, data } = response;
            if (statusCode === 200) {
                dispatch(setCertificate(data));
                return data;
            }
            return null;
        } catch (err: any) {
            dispatch(setCertificateError("No se pudo obtener el certificado público."));
            return null;
        } finally {
            dispatch(setLoading(false));
        }
    };

    // 🧩 Retorno del hook
    return {
        certificate,
        isLoading,
        error,
        fetchCertificate,
    };
};
